























































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { RouteConfig } from 'vue-router';
import store from '@/store';

@Component({
  name: 'NavList',
})
export default class NavList extends BaseComponent {
  @Prop() readonly mini: boolean;
  @Prop() readonly items: RouteConfig[];

  get myRole(): string {
    return store.state.myRole;
  }
  // created() {
  //   console.log(store.state);
  // }
}
